/* eslint-disable max-len */
import { AbstractControl, ValidationErrors } from '@angular/forms';

export class ErrorValidator {
  static cannotContainSpace(control: AbstractControl): ValidationErrors | null {
    const isWhitespace = control?.value?.startsWith(' ');
    return !isWhitespace ? null : { 'whitespace': true };
  }

  static emailValid(control: AbstractControl): ValidationErrors | null {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,15}$/;
    if (control.value?.length > 0) {
      const valid = emailRegex.test(control.value);
      return valid ? null : { invalidEmail: true };
    } else {
      return null;
    }
  }

  static companyDomainValid(control: AbstractControl): ValidationErrors | null {
    const domainRegex = /^(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;
    if (control.value?.length > 0) {
      const valid = domainRegex.test(control?.value);
      return valid ? null : { invalidDomain: true };
    } else {
      return null;
    }
  }

  static endpointValid(control: AbstractControl): ValidationErrors | null {
    const endpointRegex = /^(https?):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|xyz|realsh|[a-zA-Z]{2,}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,:\[\]?'\\+&%}{$#=~_!-]+))*\??(token=[a-zA-Z0-9-]+)?$/;
    if (control.value?.length > 0) {
      const valid = endpointRegex.test(control?.value);
      return valid ? null : { invalidEndpoint: true };
    } else {
      return null;
    }
  }
}
